module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate21.1ef2555.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate21.png
// module id = 757
// module chunks = 0